<script setup lang="ts">
import type { MenuItem } from '~/components/PageHeader.vue';
import type { SocialLinks } from '~/components/SocialLinks.vue';
const { $axios } = useNuxtApp();

type Options = {
    options: {
        fields: {
            header_logo: {
                url: string;
                width?: number;
                height?: number;
                alt?: string;
            };
            header_sublogo: {
                url: string;
                width?: number;
                height?: number;
                alt?: string;
            };
            header_sublogo_url?: string;
            header_nav_link: {
                title: string;
                url: string;
                target?: string;
            };
            footer_copyright?: string;
            social_networks: SocialLinks;
        };
        menus: {
            primary: MenuItem[];
            secondary: MenuItem[];
            footer_1: MenuItem[];
            footer_2: MenuItem[];
            privacy: MenuItem[];
        };
    };
};

const { data: options, refresh } = await useAsyncData<Options>('options', () =>
    $axios.get<null, Options>('/', {
        params: { get_json_data: 'menus' },
    })
);

const isFirstLoad = ref(true);

watchEffect(() => {
    if (isFirstLoad.value) {
        refresh();
        isFirstLoad.value = false;
    }
});
</script>

<template>
    <a class="focus:ring-blue-500 sr-only focus:not-sr-only focus:outline-none focus:ring-2" href="#main">
        Skip to Content
    </a>
    <div id="wrapper" class="flex min-h-dvh flex-col overflow-x-clip">
        <PageHeader v-if="options" :header="options" />
        <main id="main" class="flex-1">
            <slot />
        </main>
        <PageFooter v-if="options" :footer="options" />
        <a class="focus:ring-blue-500 sr-only focus:not-sr-only focus:outline-none focus:ring-2" href="#wrapper">
            Back to Top
        </a>
    </div>
    <CookiePopup />
</template>
